import React from 'react';
import { Button, Grid, Header, Icon, Loader, Popup, Segment, Table } from 'semantic-ui-react';
import axios from 'axios';
import { FormattedMessage } from 'react-intl';
import { toast, ToastContainer } from 'react-toastify';

import { FiltersOnStyle, HeaderCursor, IconHeader } from '../ProfessorInputGrades/css';
import { fetchMarks, fetchStudyType } from '../../Lookups/util';
import StudentsFilter from './StudentsFilter';
import { extractFileNameFromHeaders } from '../../DegreeDocumentPrint/util/util';
import download from 'downloadjs';

import ResultsPerPageDropdown from '../../Assets/util/ResultsPerPageDropdown';
import PaginationSegment from '../../Assets/util/PaginationSegment';
import { DEFAULT_NUMBER_OF_ITEMS_PER_PAGE } from '../../Assets/util/util';
import { ExportReactCSV } from '../../util/ExportCSV';
import SearchTableData from '../../util/SearchTableData';
import { Redirect } from 'react-router-dom';
import PaginationFront from '../../util/PaginationFront';
import ReactExport from 'react-data-export';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

const { ExcelFile } = ReactExport;
const { ExcelSheet } = ReactExport.ExcelFile;

export const fetchStudyPograms = (courseImplementationId) => axios.get(`professor/study-programs-by-course/${courseImplementationId}`);


export default class StudentsGrades extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            marks: [],
            studyTypes: [],
            studyPrograms: [],

            loading: true,

            activePage: 1,
            postsPerPage: 20,
            currentPosts: [],

            isLoading: false,
            results: [],
            value: '',
            excelData: []

        };

        this.getDataToRender = this.getDataToRender.bind(this);
        this.getAllStudents = this.getAllStudents.bind(this);
        this.getStudents = this.getStudents.bind(this);
        this.getResults = this.getResults.bind(this);

    }

    componentDidMount() {
        axios.all([fetchMarks(), fetchStudyType(), fetchStudyPograms(this.props.location.state.courseImplementationId)])
            .then(axios.spread((markRes, studyTypeRes, StudyProgramsRes) => {
                const marks = markRes.data.map(el => ({
                    key: el.id,
                    value: el.id,
                    text: ((window.$locale !== 'bs' && el.translations.length) ? el.translations.find(e => e.language === window.$locale).displayName : el.displayName),
                    passed: el.passed
                }));
                const studyTypes = studyTypeRes.data.map(el => ({
                    ...el, key: el.id, value: el.id, text: ((window.$locale !== 'bs' && el.translations.length) ? el.translations.find(e => e.language === window.$locale).displayName : el.displayName),
                }));
                const studyPrograms = StudyProgramsRes.data.map(el => ({
                    ...el,
                    key: el.studyProgramId,
                    value: el.studyProgramId,
                    text: el.departments[0].name
                }));

                this.setState({ marks, studyTypes, studyPrograms });
            }))
            .then(res => this.getAllStudents())
            .catch(err => {
                this.setState({ error: true });
                console.log('Failed to fetch marks or study types');
            });
    }

    getAllStudents() {
        if (localStorage.getItem('activeRole').substr(0, 8) === 'Asistent') {
            axios.get(`/exams/student-marks/${this.props.location.state.gradedActivityId}`)
                .then(res => {
                    const data = res.data.map(el => ({
                        ...el,
                        id: el.studentGradedActivityId,
                        studyProgram: el.studyProgramName,
                        grade: el.markId ? this.state.marks.find(e => e.key === el.markId).text : null,
                        passed: el.markId ? this.state.marks.find(e => e.key === el.markId).passed : false,
                        firstName: el.studentFirstName,
                        lastName: el.studentLastName,
                        studyP: el.departments && el.departments[0].name !== '-' ? el.departments[0].name + ' / ' + el.studyProgramName ? el.studyProgramName : ' ' : el.studyProgramBasicName ? el.studyProgramBasicName + ' / ' + el.studyProgramName ? el.studyProgramName : ' ' : el.studyProgramName ? el.studyProgramName : ' '

                    }));
                    this.setState({ data, loading: false });
                    console.log('1', data);
                    const excelData = res.data.map(el => ([
                        { value: el.studentFirstName },
                        { value: el.studentLastName },
                        { value: el.index },
                        { value: el.markId ? this.state.marks.find(e => e.key === el.markId).text : null },
                        { value: el.studyProgramBasicName },
                        { value: el.studyProgramName },
                    ]));
                    this.setState({ excelData });
                })
                .catch(err => {
                    console.log('Failed to fetch students');
                });
        } else if (this.props.location.state.gradedActivityName === 'komisijski ispit') {
            axios.get(`student-exams/${this.props.location.state.gradedActivityId}`)
                .then(res => {
                    this.setState({
                        data: res.data.map(el => ({
                            ...el,
                            markName: el.markId !== null ? this.state.marks.find(e => e.key === el.markId).text : '',
                            studyP: el.departments && el.departments[0].name !== '-' ? el.departments[0].name + ' / ' + el.studyProgramName ? el.studyProgramName : ' ' : el.studyProgramBasicName ? el.studyProgramBasicName + ' / ' + el.studyProgramName ? el.studyProgramName : ' ' : el.studyProgramName ? el.studyProgramName : ' '

                        })),
                        loading: false
                    });
                    console.log('2', this.state.data);
                    const excelData = res.data.map(el => ([
                        { value: el.firstName },
                        { value: el.lastName},
                        { value: el.index },
                        { value: el.markId ? this.state.marks.find(e => e.key === el.markId).text : null },
                        { value: el.studyProgramBasicName },
                        { value: el.studyProgramName },
                    ]));
                    this.setState({ excelData });
                })
                .catch(err => {
                    console.log('Failed to fetch registered students.');
                });
        } else {
            let obj = {};
            axios.post(`/professor/students/${this.props.location.state.gradedActivityId}/true/true/0/0`, { ...obj })
                .then(res => {
                    const data = res.data.responseList.map(el => ({
                        ...el,
                        id: el.studentGradedActivityId,
                        studyProgram: el.studyProgramName,
                        studyType: this.state.studyTypes.find(e => el.studyTypeId === e.key).text,
                        grade: el.markId ? this.state.marks.find(e => e.key === el.markId).text : null,
                        passed: el.markId ? this.state.marks.find(e => e.key === el.markId).passed : false,
                        studyP: el.departments && el.departments[0].name !== '-' ? el.departments[0].name + ' / ' + el.studyProgramName ? el.studyProgramName : ' ' : el.studyProgramBasicName ? el.studyProgramBasicName + ' / ' + el.studyProgramName ? el.studyProgramName : ' ' : el.studyProgramName ? el.studyProgramName : ' '

                    }));
                    let clean = data.filter((arr, index, self) =>
                        index === self.findIndex((t) => (t.firstName === arr.firstName && t.lastName === arr.lastName && t.index === arr.index)));//todo: dodati i markid
                    this.setState({ data: clean, loading: false, totalPages: res.data.total });
                    const excelData = res.data.responseList.map(el => ([
                        { value: el.firstName },
                        { value: el.lastName },
                        { value: el.index },
                        { value: el.markId ? this.state.marks.find(e => e.key === el.markId).text : null },
                        { value: el.studyProgramBasicName },
                        { value: el.studyProgramName },
                    ]));
                    this.setState({ excelData });
                })
                .catch(err => {
                    this.setState({ error: true });
                    console.log('Failed to fetch students');
                });
        }
    }


    getDataToRender() {
        if (this.state.results.length !== 0) {
            return this.state.results;
        }
        return this.state.data;
    }

    getResults(results) {
        this.setState({ results });
        this.handlePaginationChange({}, {activePage: 1})
    }

    handlePaginationChange = (e, { activePage }) => this.setState({ activePage })

    getStudents() {
        let obj = {
            gradedActivityId: this.props.location.state.gradedActivityId,
            language: 'bs'
        };
        axios({
            method: 'post',
            url: '/documents/exam-marks',
            responseType: 'blob',
            data: { ...obj }
        })
            .then(res => {
                if (res.data.size === 0) {
                    return;
                }
                const fileName = extractFileNameFromHeaders(res.headers);
                download(res.data, fileName);
                return res;
            })
            .catch(err => {
                toast('Došlo je do greške! Zahtjev nije obrađen.');
            });
    }


    render() {
        const { isLoading, value, results } = this.state;
        const headersForExport = [
            { label: 'Prezime', key: 'lastName' },
            { label: 'Ime', key: 'firstName' },
            { label: 'Index', key: 'index' },
            { label: 'Ocjena', key: 'grade' },
            { label: 'Studijski program', key: 'studyProgramBasicName' },
            { label: 'Nastavni plan i program', key: 'studyProgram' },
        ];

        const multiDataSet = [
            {
                columns: [
                    { title: 'Ime', width: { wpx: 150 } },
                    { title: 'Prezime', width: { wpx: 150 } },
                    { title: 'Index', width: { wpx: 150 } },
                    { title: 'Ocjena', width: { wpx: 150 } },
                    { title: 'Studijski program', width: { wpx: 300 } },
                    { title: 'Nastavni plan i program', width: { wpx: 300 } },
                ],
                data: this.state.excelData,
            }
        ];

        const indexOfLastPost = this.state.activePage * this.state.postsPerPage;
        const indexOfFirstPost = indexOfLastPost - this.state.postsPerPage;
        const currentPosts = this.getDataToRender().slice(indexOfFirstPost, indexOfLastPost);

        if (this.state.showStudentInfo === true) {
            return (
                <FormattedMessage id="route.studentGradesAndInfoFromFinalised">
                    {(msg) => (<Redirect
                        push
                        to={{
                            pathname: msg,
                            state: {
                                studentId: this.state.studentId, sspId: this.state.sspId, studyProgramId: this.state.studyProgramId
                            }
                        }}
                    />)}
                </FormattedMessage>);
        }
        return (
            <div>
                <Header as="h1">  <FormattedMessage id="common.studentsList" /></Header>
                <Segment.Group raised >
                    <Segment clearing>
                        <Header as="h3">
                            <Header.Content>
                                {this.props.location.state.courseImplementationName} / {this.props.location.state.gradedActivityName} / {this.props.location.state.date}
                                <Header.Subheader> <FormattedMessage id="professorStatistics.courseExamDate" /></Header.Subheader>
                            </Header.Content>
                            <Header style={IconHeader} floated="right" >
                                <Icon />
                                <Popup
                                    trigger={<Icon
                                        link
                                        circular
                                        basic="true"
                                        floated="right"
                                        name="arrow left"
                                        onClick={() => window.history.go(-1)}
                                    />}
                                    content={<FormattedMessage id="common.back" />}
                                    hideOnScroll
                                    position="top center"
                                />
                            </Header>
                            {/* {this.props.location.state.courseImplementationName} / {this.props.location.state.gradedActivityName} / {this.props.location.state.date} */}
                            {/* {(this.props.location.state.gradedActivityName !== 'komisijski ispit' && localStorage.getItem('activeRole').substr(0, 8) === 'Profesor') && <Header style={IconHeader} floated="right" > */}
                            {/*    {(!this.state.showFiltersOnButton && this.getDataToRender().length > 0) && */}
                            {/*    <span style={{ float: 'left' }}><ResultsPerPageDropdown */}
                            {/*        resultsPerPage={this.state.resultsPerPage} */}
                            {/*        onResultsPerPageChange={this.handleResultsPerPageChange} */}
                            {/*    /></span>} */}
                            {/* </Header>} */}


                        </Header>


                    </Segment>

                    {this.state.loading ? <Segment><div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div></Segment> :
                        <Segment>
                        {/*{(this.props.location.state.gradedActivityName !== 'komisijski ispit' && localStorage.getItem('activeRole').substr(0, 8) === 'Profesor') && <Header style={IconHeader} floated="right" >*/}
                        {/*        {(!this.state.showFiltersOnButton && this.getDataToRender().length > 0) &&*/}
                        {/*        <span style={{ float: 'left' }}><ResultsPerPageDropdown*/}
                        {/*            resultsPerPage={this.state.resultsPerPage}*/}
                        {/*            onResultsPerPageChange={this.handleResultsPerPageChange}*/}
                        {/*        /></span>}*/}
                        {/*    </Header>}*/}
                        {currentPosts.length ?
                                <Table celled selectable>
                                <Table.Header>
                                        <Table.Row>
                                        <Table.HeaderCell colSpan={localStorage.getItem('activeRole').substr(0, 8) === 'Profesor' ? 14 : 12} >
                                                <span>
                                                <Grid stackable columns={this.props.location.state.gradedActivityName !== 'komisijski ispit' ? 3 : 2} >

                                                        <Grid.Column width={this.props.location.state.gradedActivityName !== 'komisijski ispit' ? 12 : 14}>
                                                        <SearchTableData profMozilla data={this.state.data} getResults={this.getResults} filterItem={['firstName', 'lastName', 'index', 'studyProgram', 'studyProgramBasicName', 'studyType', 'markName', 'grade']} />
                                                    </Grid.Column>

                                                        {this.props.location.state.gradedActivityName !== 'komisijski ispit' &&
                                                        <Grid.Column width={2} style={{ paddingRight: '5px' }}>
                                                            <Popup
                                                                trigger={
                                                                    <Button
                                                                        animated="vertical"
                                                                        fluid
                                                                        color="red"
                                                                        basic
                                                                        onClick={this.getStudents}
                                                                    >
                                                                        <Button.Content hidden> <Icon name="download" /></Button.Content>
                                                                        <Button.Content visible>
                                                                            PDF
                                                                        </Button.Content>
                                                                    </Button>
                                                                }
                                                                content="Preuzmi spisak u PDF-u"
                                                                hideOnScroll
                                                                position="top center"
                                                            />
                                                        </Grid.Column>
                                                        }

                                                        <Grid.Column width={2} style={{ paddingLeft: '5px' }}>

                                                        {this.state.data &&
                                                        <ExcelFile filename="Spisak studenata na ispitu sa ocjenama" element={<Popup
                                                            trigger={<Button animated="vertical" color='green' basic floated='right' fluid style={{ textAlign: 'center' }}>
                                                                <Button.Content hidden> <Icon name="download" /></Button.Content>
                                                                <Button.Content visible>
                                                                    Excel
                                                                </Button.Content>
                                                            </Button>}
                                                            content="Preuzmi spisak u Excel-u"
                                                            hideOnScroll
                                                            position="top center"
                                                        />}>
                                                            <ExcelSheet dataSet={multiDataSet} name="Studenti" />
                                                        </ExcelFile>
                                                            // <ExportReactCSV
                                                            //     color="green"
                                                            //     csvData={this.state.data}
                                                            //     headers={headersForExport}
                                                            //     fluid
                                                            //     fileName="Spisak studenata na ispitu sa ocjenama"
                                                            // />
                                                        }

                                                    </Grid.Column>
                                                    </Grid>
                                            </span>

                                            </Table.HeaderCell>
                                    </Table.Row>
                                        <Table.Row>
                                        <Table.HeaderCell width={1}>
                                                <FormattedMessage id="common.ordinal" />
                                            </Table.HeaderCell>
                                        <Table.HeaderCell colSpan={2}>
                                                <FormattedMessage id="common.index" />
                                            </Table.HeaderCell>

                                        <Table.HeaderCell colSpan={2}>
                                                <FormattedMessage id="common.firstName" />
                                            </Table.HeaderCell>
                                        <Table.HeaderCell colSpan={2}>
                                                <FormattedMessage id="common.lastName" />
                                            </Table.HeaderCell>
                                        <Table.HeaderCell colSpan={3}>
                                                <FormattedMessage id="professorInputGrades.studyProgram" />
                                            </Table.HeaderCell>
                                        {localStorage.getItem('activeRole').substr(0, 8) === 'Profesor' && <Table.HeaderCell colSpan={2}>
                                                <FormattedMessage id="professorInputGrades.studentStudyType" />
                                            </Table.HeaderCell>}
                                        <Table.HeaderCell colSpan={2}>
                                                <FormattedMessage id="common.grade" />
                                            </Table.HeaderCell>

                                    </Table.Row>
                                    </Table.Header>
                                <Table.Body> {currentPosts.map((el, index) =>
                                        (<Table.Row key={el.studentGradedActivityId} style={HeaderCursor}>
                                            <Table.Cell verticalAlign="middle">
                                                {(index + 1) + ((this.state.activePage - 1) * this.state.postsPerPage)}.
                                                {/*{(this.state.page * this.state.resultsPerPage) + index + 1}.*/}
                                            </Table.Cell>
                                            <Table.Cell colSpan={2} verticalAlign="middle">
                                                {el.index}
                                            </Table.Cell>

                                            <Popup
                                                content={<FormattedMessage id="professorInputGrades.showStudentInfo" />}
                                                hideOnScroll
                                                position="top center"
                                                trigger={
                                                    <Table.Cell
                                                        colSpan={2}
                                                        verticalAlign="middle"
                                                        onClick={() => this.setState({
                                                            studentId: el.studentId, sspId: el.studentStudyProgramId, studyProgramId: el.studyProgramId, showStudentInfo: true
                                                        })}
                                                    >
                                                        {el.firstName}
                                                    </Table.Cell>}
                                            />
                                            <Popup
                                                content={<FormattedMessage id="professorInputGrades.showStudentInfo" />}
                                                hideOnScroll
                                                position="top center"
                                                trigger={
                                                    <Table.Cell
                                                        colSpan={2}
                                                        verticalAlign="middle"
                                                        onClick={() => this.setState({
                                                            studentId: el.studentId, sspId: el.studentStudyProgramId, studyProgramId: el.studyProgramId, showStudentInfo: true
                                                        })}
                                                    >
                                                        {el.lastName}
                                                    </Table.Cell>
                                                }
                                            />
                                            <Table.Cell colSpan={3} verticalAlign="middle">
                                                <strong>{el.departments && el.departments[0].name !== '-' ? el.studyProgramBasicName ? el.departments[0].name + ' | ' + el.studyProgramBasicName : ' ' : el.studyProgramBasicName ? ' | ' + el.studyProgramBasicName : ' '}</strong> {el.studyProgram ? ' | ' + el.studyProgram : ''}
                                            </Table.Cell>
                                            {localStorage.getItem('activeRole').substr(0, 8) === 'Profesor' && <Table.Cell colSpan={2} verticalAlign="middle">
                                                {el.markName ? '' : el.studyType}
                                            </Table.Cell>}
                                            <Table.Cell verticalAlign="middle" colSpan={2}>
                                                {el.markName ? el.markName : el.grade}
                                            </Table.Cell>
                                        </Table.Row>))}
                                    </Table.Body>
                            </Table>
                                // : this.state.showFiltersOnButton ?
                                //     <FormattedMessage id="professorInputGrades.CurrentGradesFilterMessage" />
                                    : <FormattedMessage id="professorInputGrades.PreviousGradesMessage" />

                            }
                            {currentPosts.length >0 && <PaginationFront postsPerPage={this.state.postsPerPage} totalPosts={this.getDataToRender().length} paginate={this.handlePaginationChange} activePage={this.state.activePage} />}

                        </Segment>}

                    <ToastContainer hideProgressBar />
                </Segment.Group>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Professor/ProfessorHistoryGrades/StudentsGrades.js